export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";